import dayjs from 'dayjs';

export const isTimestampExpired = (timestamp: number): boolean => {
  const currentTimeInSeconds = dayjs().unix();
  return timestamp < currentTimeInSeconds;
};
